/*
Created by: Alby Anna Ulahannan
Created on: 06-09-2024
Page Description: This page implements the change password functionality for the Al Mal Capital web application.
Users can enter a new password and confirm it to reset their password. 
The new password must be at least 8 characters long, include an uppercase letter, a number, and a special character.
Error messages are displayed for invalid password input or if passwords do not match.
*/

import React, { useState } from "react";
import Eye from "../images/eye.png"
import HideEye from "../images/hide.png"
import "../css/style.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import { useNavigate } from 'react-router-dom';
import { callingAPIWithoutAuth } from "../service"
import ChangePassword from "../pages/changePassword"


export default function ForgotPassword({ setShowForgotPassword }) {
    const [userId, setUserId] = useState("");
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [resetToken, setResetToken] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [otpValidated, setOtpValidated] = useState(false);
    const navigate = useNavigate();


    const handleGetOtp = () => {
        if (userId === "") {
            setError("Enter User ID");
            return;
        }

        const postData = {
            "userId": userId,
        }
        callingAPIWithoutAuth(postData, "user/sendOTP", 'post')
            .then((response) => {
                const { data } = response;
                console.log("🚀 ~ .then ~ response:", response)
                if (data.statusCode === 200) {
                    setError(data.data.message);
                    setOtpSent(true);
                }
                else {
                    console.log("🚀 ~ handleGetOtp ~ errordata:", data)
                    setError(data.message);
                }
            })
            .catch((error) => {
                console.log("🚀 ~ handleGetOtp ~ error:", error)
                setError(error.response.data.message);
            });
    };


    const handleBackToLogin = () => {
        setShowForgotPassword(false);
    };

    const handleValidateOtp = () => {
        if (otp === "") {
            setError("Enter OTP");
            return;
        }

        const postData = {
            userId: userId,
            otp: otp,
        };

        callingAPIWithoutAuth(postData, "user/validateOTP", 'post')
            .then((response) => {
                console.log("🚀 ~ .then ~ response:", response);
                const { data } = response;
                if (data.statusCode === 200) {
                    if (data?.data?.resetToken) {
                        window.sessionStorage.setItem("resetToken", data?.data?.resetToken);
                        setResetToken(data?.data?.resetToken)
                        setOtpValidated(true);
                    }
                    setError(data.message);

                } else {
                    setError(data.message);
                    setOtpValidated(false);
                }
            })
            .catch((error) => {
                console.error("API call error:", error.response || error);
                console.error("API call errorqq:", error);
                setError(error.response.data.message);
                setOtpValidated(false);
            });
    };


    return (

        <>
            {otpValidated ? (
                // <ChangePassword setShowForgotPassword={setShowForgotPassword} userId={userId} resetToken={resetToken} />
                <ChangePassword setShowForgotPassword={setShowForgotPassword} userId={userId} />
            ) : (

                <div className="login-form-wrap">
                    <h1 className="login-head mb-4">Forgot Password</h1>

                    <div className="col-12 position-relative">
                        <div className="d-flex justify-content-center">
                            {error && <p className="err-msg-text err-msg-text-top error-forgotPasswrd" >{error}</p>}
                        </div>
                        {!otpSent &&
                            <div className={`form-labels-outer mt-4 ${otpSent ? "mb-2" : ""}`}>
                                <label htmlFor="userId" className="form-label">User ID</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter User ID"
                                    value={userId}
                                    onChange={(e) => setUserId(e.target.value)}
                                />
                            </div>}

                        {otpSent && (
                            <>
                                {/* <p className="change-password-text otp-successmsg mb-0">{error}</p> */}
                                <div className="form-labels-outer mt-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter OTP"
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value)}
                                    />
                                </div>
                            </>
                        )}
                        <div>
                            <button className="btn btn-login btn-block" onClick={otpSent ? handleValidateOtp : handleGetOtp}> {otpSent ? "Validate OTP" : "Get OTP"}</button>
                        </div>

                        <div className="forgot-pass-sec">
                            <a className="forgot-passtext" onClick={handleBackToLogin}>Back To Login</a>
                        </div>
                    </div>
                </div>
            )}
        </>

    )
}
